<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<v-row no-gutters>
				<v-checkbox
					class="mt-4 mr-2"
					label="承認待ちを表示"
					v-model="q.waiting_for_approval"
					hide-details
				/>
				<v-checkbox
					class="mt-4 mr-2"
					label="確認待ちを表示"
					v-model="q.waiting_for_confirmation"
					hide-details
				/>
				<v-checkbox
					class="mt-4 mr-2"
					label="自分に関するもののみ"
					v-model="q.related_to_user"
					hide-details
				/>
			</v-row>
			<v-tabs
				class="mt-4"
				v-model="tab"
				height="40px"
				slider-color="primary"
				color="black"
				@change="selectTab"
			>
				<v-tab v-for="(item, i) in tabs" :key="i">
					{{ item.name }}
				</v-tab>
			</v-tabs>
			<v-tabs-items v-model="tab" class="pa-2" @change="selectTab">
				<QuotationTab :q="q" :isFetched="isFetched('見積')" />
				<RequirementTab :q="q" :isFetched="isFetched('依頼')" />
				<OrderConfirmationTab :q="q" :isFetched="isFetched('受注')" />
			</v-tabs-items>
		</CommonFlame>
	</div>
</template>

<script>
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import RequirementTab from "./tabs/RequirementTab.vue"
import OrderConfirmationTab from "./tabs/OrderConfirmationTab.vue"
import QuotationTab from "./tabs/QuotationTab.vue"

export default {
	components: {
		CommonFlame,
		RequirementTab,
		OrderConfirmationTab,
		QuotationTab,
	},
	data() {
		return {
			title: "確認・承認待ち一覧",
			tab: 0,
			tabs: [
				{ name: "見積", isFetched: false },
				{ name: "依頼", isFetched: false },
				{ name: "受注", isFetched: false },
			],
			q: {
				waiting_for_approval: true,
				waiting_for_confirmation: true,
				related_to_user: true,
			},
			common,
		}
	},
	mounted() {
		this.selectTab()
	},
	methods: {
		selectTab() {
			this.tabs[this.tab].isFetched = true
		},
	},
	computed: {
		isFetched() {
			return (name) => {
				const tab = this.tabs.find((t) => t.name == name)
				return tab != null ? tab.isFetched : false
			}
		},
	},
}
</script>
